import React from 'react';
import { userServices } from '../../APIServices/userServices';

function Sidebar({
  active,
  setActive,
  groups,
  modules,
  counts,
  currentUserData,
}) {
  const logoutAdmin = async (e) => {
    e.preventDefault();
    await userServices.logout({});
  };
  return (
    <div className="sidebar-wrapper">
      {/* Mini Sidebar */}
      <div className="mini-sidebar">
        <div className="mini-sidebar-brand">
          <span className="mini-brand-icon">A</span>
        </div>

        <nav className="mini-nav">
          <button
            className={`mini-nav-item ${active === 'dashboard' ? 'active' : ''}`}
            onClick={() => setActive('dashboard')}
            title="Dashboard"
          >
            <i className="ti ti-home" />
          </button>

          <button
            className={`mini-nav-item ${active === 'protocolReview' ? 'active' : ''}`}
            onClick={() => setActive('protocolReview')}
            title="Study Document Review"
          >
            <i className="ti ti-file-text" />
          </button>

          <button
            className={`mini-nav-item ${active === 'knowledge' ? 'active' : ''}`}
            onClick={() => setActive('knowledge')}
            title="Intelligence"
          >
            <i className="ti ti-books" />
          </button>

          <button
            className={`mini-nav-item ${active === 'audit' ? 'active' : ''}`}
            onClick={() => setActive('audit')}
            title="Audit Trail"
          >
            <i className="ti ti-history" />
          </button>

          <button
            className={`mini-nav-item ${active === 'profile' ? 'active' : ''}`}
            onClick={() => setActive('profile')}
            title="Profile"
          >
            <i className="ti ti-user-check" />
          </button>
        </nav>
        <div className="mini-sidebar-footer">
          <button
            className="mini-nav-item logout"
            onClick={logoutAdmin}
            title="Sign Out"
          >
            <i className="ti ti-logout" />
          </button>
        </div>
      </div>

      {/* Main Sidebar */}
      <aside className="sidebar">
        <div className="brand">
          <div className="brand-mark">Pivot</div>
          <div className="brand-sub">IQ Workspace</div>
        </div>

        <nav className="nav">
          {groups.map((group) => (
            <div key={group.id} className="nav-group">
              <div className="nav-group-label">{group.label}</div>

              {Object.entries(modules)
                .filter(([_, module]) => module.group === group.id)
                .map(([key, module]) => (
                  <button
                    key={key}
                    className={`nav-item ${active === key ? 'active' : ''}`}
                    onClick={() => setActive(key)}
                  >
                    <i className={`ti ${module.icon}`} />
                    <span>{module.name}</span>

                    {counts?.[key] > 0 && (
                      <span className="nav-badge">{counts[key]}</span>
                    )}
                  </button>
                ))}
            </div>
          ))}
        </nav>

        <div className="sidebar-foot">
          <div className="user-avatar">
            {currentUserData?.roleType === "admin" ? "A" : "SA"}
          </div>

          <div className="sidebar-user-details">
            <div className="user-name truncate">
              {[currentUserData?.firstName, currentUserData?.middleName, currentUserData?.lastName]
                .filter(Boolean)
                .join(" ")}
            </div>

            <div className="user-role">
              User
            </div>
          </div>
        </div>
      </aside>
    </div>
  );
}

export default Sidebar;
